// extracted by mini-css-extract-plugin
export default {"rating":"oD-z","numberOfStars":"pD-z","count":"qD-z","barGraphSpacing":"rD-z","barGraph":"sD-z"};